import { Component, OnInit, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { EventService } from '../../core/services/event.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-rightsidebar',
    templateUrl: './rightsidebar.component.html',
    styleUrls: ['./rightsidebar.component.scss'],
    standalone: false
})

/**
 * Right Sidebar component
 */
export class RightsidebarComponent implements OnInit {

  layout: string | undefined;
  theme: string | undefined;
  themecolor: string | undefined;
  mode: string | undefined;
  width: string | undefined;
  position: string | undefined;
  topbar: string | undefined;
  size: string | undefined;
  sidebarView: string | undefined;
  sidebar: string | undefined;
  attribute: any;
  sidebarImage: any;
  sidebarVisibility: any;
  preLoader: any;
  grd: any;
  backgroundImage: any

  @ViewChild('filtetcontent') filtetcontent!: TemplateRef<any>;
  @Output() settingsButtonClicked = new EventEmitter();

  constructor(private eventService: EventService, private offcanvasService: NgbOffcanvas) { }

  ngOnInit(): void {
    // Set default values
    this.layout = 'vertical';
    this.theme = 'default';
    this.themecolor = 'default';
    this.mode = 'light';
    this.width = 'fluid';
    this.position = 'fixed';
    this.topbar = 'light';
    this.size = 'lg';
    this.sidebarView = 'default';
    this.sidebar = 'dark';
    this.sidebarImage = 'none';
    this.preLoader = 'disable';
    this.sidebarVisibility = 'show';

    setTimeout(() => {
      if (this.offcanvasService.hasOpenOffcanvas() == false) {
        this.openEnd(this.filtetcontent);
      };
    }, 1000);
  }

  ngAfterViewInit() { }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.attribute = layout;
    this.layout = layout;
    document.documentElement.setAttribute('data-layout', layout);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }


  // Add Active Class
  addActive(grdSidebar: any) {
    this.grd = grdSidebar;
    document.documentElement.setAttribute('data-sidebar', grdSidebar)
    document.getElementById('collapseBgGradient')?.classList.toggle('show');
    document.getElementById('collapseBgGradient1')?.classList.add('active');
  }

  // Remove Active Class
  removeActive() {
    this.grd = '';
    document.getElementById('collapseBgGradient1')?.classList.remove('active');
    document.getElementById('collapseBgGradient')?.classList.remove('show');
  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  //  Filter Offcanvas Set
  openEnd(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'end' });

    setTimeout(() => {
      this.attribute = document.documentElement.getAttribute('data-layout')
      if (this.attribute == 'vertical') {
        var vertical = document.getElementById('customizer-layout01') as HTMLInputElement;
        if (vertical != null) {
          vertical.setAttribute('checked', 'true');
        }
      }
      if (this.attribute == 'horizontal') {
        const horizontal = document.getElementById('customizer-layout02');
        if (horizontal != null) {
          horizontal.setAttribute('checked', 'true');
        }
      }
      if (this.attribute == 'twocolumn') {
        const Twocolumn = document.getElementById('customizer-layout03');
        if (Twocolumn != null) {
          Twocolumn.setAttribute('checked', 'true');
        }
      }
      if (this.attribute == 'semibox') {
        const Twocolumn = document.getElementById('customizer-layout04');
        if (Twocolumn != null) {
          Twocolumn.setAttribute('checked', 'true');
        }
      }
    }, 100);
  }

  // Show Profile Sidebar
  showSidebarProgile(event: any) {
    if (event.target.checked == true) {
      document.documentElement.setAttribute("data-sidebar-user-show", "")
    } else {
      document.documentElement.removeAttribute("data-sidebar-user-show")
    }
  }

  // Theme Change
  changelayoutTheme(theme: string) {
    this.theme = theme;
    document.documentElement.setAttribute('data-theme', theme);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  // Change Theme Color
  changeColor(themecolor: string) {
    this.themecolor = themecolor;
    document.documentElement.setAttribute('data-theme-colors', themecolor);
  }

  // Mode Change
  changeLayoutMode(mode: string) {
    this.mode = mode;
    document.documentElement.setAttribute('data-bs-theme', mode);
  }

  // Visibility Change
  changeVisibility(sidebarvisibility: string) {
    this.sidebarVisibility = sidebarvisibility;
    document.documentElement.setAttribute('data-sidebar-visibility', sidebarvisibility);
  }

  // Width Change
  changeWidth(layoutWidth: string, size: string) {
    this.width = layoutWidth;
    document.documentElement.setAttribute('data-layout-width', layoutWidth);
    document.documentElement.setAttribute('data-sidebar-size', size);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  // Position Change
  changePosition(layoutPosition: string) {
    this.position = layoutPosition;
    document.documentElement.setAttribute('data-layout-position', layoutPosition);
  }

  // Topbar Change
  changeTopColor(topbarColor: string) {
    this.topbar = topbarColor;
    document.documentElement.setAttribute('data-topbar', topbarColor);
  }

  // Sidebar Size Change
  changeSidebarSize(sidebarSize: string) {
    this.size = sidebarSize;
    document.documentElement.setAttribute('data-sidebar-size', sidebarSize);
  }

  // Sidebar Size Change
  changeSidebar(sidebarView: string) {
    this.sidebarView = sidebarView;
    document.documentElement.setAttribute('data-layout-style', sidebarView);
  }

  // Sidebar Color Change
  changeSidebarColor(sidebarColor: string) {
    this.sidebar = sidebarColor;
    document.documentElement.setAttribute('data-sidebar', sidebarColor);
  }

  // Sidebar Image Change
  changeSidebarImage(sidebarImage: string) {
    this.sidebarImage = sidebarImage;
    document.documentElement.setAttribute('data-sidebar-image', sidebarImage);
  }

  // Sidebar Image Change
  changeBackgroundImage(backgroundImage: string) {
    this.backgroundImage = backgroundImage;
    document.documentElement.setAttribute('data-body-image', backgroundImage);
  }

  // PreLoader Image Change
  changeLoader(Preloader: string) {
    this.preLoader = Preloader;
    document.documentElement.setAttribute('data-preloader', Preloader);
    var preloader = document.getElementById("preloader");
    if (preloader) {
      setTimeout(function () {
        (document.getElementById("preloader") as HTMLElement).style.opacity = "0";
        (document.getElementById("preloader") as HTMLElement).style.visibility = "hidden";
      }, 1000);
    }
  }

}
